import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import ProductCatalog from "./components/ProductCatalog";
import OperationalExcellence from "./components/OperationalExcellence";
import GlobalFootprint from "./components/GlobalFootprint";
import LogisticsPackaging from "./components/LogisticsPackaging";
import CertificationGallery from "./components/CertificationGallery";
import QuoteForm from "./components/QuoteForm";
import Footer from "./components/Footer";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-slate-50 text-center">
        <div className="w-8 h-8 border-2 border-brand-green border-t-transparent rounded-full animate-spin mb-4" />
        <p className="text-sm text-slate-500">Loading...</p>
      </div>
    );
  }
  if (!user || user === false) return <Navigate to="/admin/login" replace />;
  return children;
}

function LandingPage() {
  return (
    <LanguageProvider>
      <div className="min-h-screen bg-slate-50">
        <Navbar />
        <HeroSection />
        <ProductCatalog />
        <OperationalExcellence />
        <GlobalFootprint />
        <LogisticsPackaging />
        <CertificationGallery />
        <QuoteForm />
        <Footer />
      </div>
    </LanguageProvider>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
